import { Facade } from '@niknevis/vue-modules'
import { ZiggyService as ZiggyService } from '../ziggy'

export class Ziggy extends Facade<ZiggyService>() {
  static getFacadeAccessor() {
    return ZiggyService
  }
}
